<template>
  <div class="Zhusu">
    <div class="container">
      <h2>助学住宿预订服务</h2>
      <p>符合条件的申请人可通过助学住宿预订服务系统预订大学住宿。这项服务主要提供学生宿舍的选择。您可以在登录助学账户后预订住宿。如果你对住在校园里不感兴趣，助学还会指导你选择附近的酒店。</p>
      <p>非助学用户只能预订北京的大学的住宿，使用此项服务将收取100美元的费用。</p>
      <div class="tips">提示</div>
      <p class="tips_p">由于宿舍可能存在不足的情况，我们建议您在收到入学通知后立即预订住宿。</p>
      <p>一些大学不接受预订房间，并采取“先到先得”的原则。所以助学建议你在注册期间早点过来。</p>
      <div class="shenqingTit">预约程序</div>
      <div class="buzhu">
        <van-steps direction="vertical"
                   :active="10">
          <van-step>
            <h3>STEP 1</h3>
            <div class="lis">
              <h4>了解住宿信息</h4>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 2</h3>
            <div class="lis">
              <h4>在线填写申请表</h4>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 3</h3>
            <div class="lis">
              <h4>支付100美元服务费</h4>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 4</h3>
            <div class="lis">
              <h4>接收预订通知</h4>
              <div class="tips_lis">ps：如需住宿预约服务，点击 <b @click="showForm = true"
                   style="color:#263e65">申请住宿</b> ，我们会尽快联系您。</div>
            </div>
          </van-step>
        </van-steps>
      </div>
      <div class="shenqingTit">服务标准</div>
      <p>申请表提交后一个工作日内将开始预订宿舍</p>
      <p>我们收到预订成功的通知后，将通过电子邮件通知学生</p>
      <p>学生出发前将与学校再次确认</p>
      <div class="shenqingTit">常见问题</div>
    </div>
    <div class="cont-card">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="item.title"
                           :name="index"
                           v-for="(item,index) in faq"
                           :key="index">
          <div v-html="item.content"
               class="faq-detail"></div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=8
                 formTitle="申请住宿"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm'
import axiosApi from "../api/api.js";

export default {
  name: 'Zhusu',
  components: {
    ComForm
  },
  data () {
    return {
      activeNames: ['0'],
      faq: [{
        ft: '在什么情况下我的预订会失败？',
        fa: '以下两种情况可能导致宿舍预订失败：您所在的大学不提供校内宿舍；宿舍不足。'
      },
      {
        ft: '我可以住在校外吗？',
        fa: '这是许多中国大学所允许的。'
      },
      {
        ft: '我能让我的家人和我一起住在校园里吗？',
        fa: '这是某些中国大学允许的。'
      },
      {
        ft: '我在申请表中勾选了单人房，为什么会显示双人房预订？',
        fa: '由于数量不足，贵校无法满足所有学生的要求。如果您同意转房，助学将为您预订双人房，以保证您在校园内的住宿。'
      },
      {
        ft: '我到达时住宿费会调整吗？',
        fa: '助学及其他相关文件的信息均来自学校，仅供参考。注册期间可能会发生变更。'
      },
      {
        ft: '我可以在注册期前办理登机手续吗？',
        fa: '一些大学允许学生在注册日期之前来。'
      },
      {
        ft: '如果我错过了注册怎么办？',
        fa: '大学要求学生按时注册。如果你不准时，你应该立即与助学或你所在的大学联系，请求允许。否则，您将被视为放弃注册。'
      },
      {
        ft: '我没有预订住宿。如果我到达时没有房间，我该怎么办？',
        fa: '助学建议学生提前预订住宿。如果您到达后没有房间，请联系学校或助学寻求帮助。助学可以在校外找到住宿信息。'
      }
      ],
      showForm: false
    }
  },
  methods: {
    hideForm () {
      this.showForm = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    }
  },
  mounted () {
    axiosApi(
      'news/30', {}, 'get'
    ).then((res) => {
      this.faq = res.data.data
    })
  }
}
</script>

<style lang="scss" scoped>
.Zhusu {
  height: 100%;
  overflow: auto;
}
.container {
  padding-bottom: 0;
  h2 {
    text-align: center;
  }
  h4 {
    margin: 0;
  }
  font-size: 28px;
  p {
    margin-bottom: 20px;
    text-indent: 2em;
  }
  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}
[class*="van-hairline"]::after {
  border: none;
}
.cont-card {
  padding: 20px 0;
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
